

import React, { useEffect, useState } from "react";
import { fetchAQI } from "../services/airQuality";

const AirQuality = ({ latitude, longitude }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [data, setData] = useState(null);

  useEffect(() => {
    if (typeof latitude !== "number" || typeof longitude !== "number" || isNaN(latitude) || isNaN(longitude)) {
      setError("Invalid coordinates");
      setData(null);
      setLoading(false);
      return;
    }
    setLoading(true);
    setError("");
    setData(null);
    fetchAQI(latitude, longitude)
      .then((json) => setData(json))
      .catch(() => setError("Failed to fetch AQI data"))
      .finally(() => setLoading(false));
  }, [latitude, longitude]);

  return (
    <div style={{ padding: 8, background: '#fef9c3', borderRadius: 6 }}>
      <strong>Air Quality:</strong>
      <div>Lat: {latitude}, Lng: {longitude}</div>
      {loading ? (
        <div>Loading...</div>
      ) : error ? (
        <div style={{ color: 'red' }}>{error}</div>
      ) : Array.isArray(data) && data.length > 0 ? (
        <div>
          {data.slice(0, 2).map((aqi, idx) => (
            <div key={aqi.DateObserved + aqi.ParameterName + idx}>
              <span>{aqi.ParameterName}: AQI {aqi.AQI} ({aqi.Category?.Name})</span>
            </div>
          ))}
        </div>
      ) : (
        <div>No air quality data available.</div>
      )}
    </div>
  );
};

export default AirQuality;
